import React, { useState } from 'react';
import t from 'react-translate';

// redux
import { useAppDispatch } from 'redux/store';
import { useSelector } from 'react-redux';
import { getCourseAliases, getCurrentCourse, getFlatCourseAliases } from 'redux/selectors/course';
import { getBulkConvertibleLecturePagesData } from 'redux/selectors/collections';

// components
import TopPanelActionButton from 'lecture_pages/components/edit-menu/actions/top-panel-action-button';
import BulkAddToCollectionModal, { BulkAddToCollectionSourceType } from 'courses/components/course-lesson-to-collection/bulk-add-to-collection-modal';
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import { config } from '../../../../../config/config.json';
import { checkBulkConvertibleLecturePagesEligibility } from './check-bulk-convertible-lecture-pages-eligibility';


const BulkAddToCollectionButton = () => {
  const dispatch = useAppDispatch();
  const course = useSelector((state) => getCurrentCourse(state));
  const params = useLecturePageParams();
  const courseAliases = useSelector(state => getFlatCourseAliases(state, params.catalogId));
  const aliases = useSelector(getCourseAliases);
  const canBulkConvertToCollectionLesson = useSelector(state => state.app.collection.canBulkConvertToCollectionLesson);
  const bulkConvertInProgress = useSelector(state => state.app.collection.bulkConvertInProgress);
  const convertibleLecturePagesData = useSelector((state) => getBulkConvertibleLecturePagesData(state, course.id));
  const courseConvertibleLecturePagesCount = convertibleLecturePagesData?.convertibleLecturePagesCount
  ?? course?.convertibleLecturePagesCount ?? 0;

  const isBulkAddToLessonLibraryEnabled = courseConvertibleLecturePagesCount > 0;
  const [showBulkAddToLessonModal, setShowBulkAddToLessonModal] = useState(false);
  const [bulkConvertibleLessonsCount, setBulkConvertibleLessonsCount] = useState(0);
  const bulkAddToCollectionButtonToolTipAndAriaLabelText = !bulkConvertInProgress
    ? t.TIMELINE.LL_BULK_CONVERT_LECTURE_PAGES.ADD_TO_LL_TOOLTIP_TEXT(aliases.lectureAliases)
    : t.TIMELINE.LL_BULK_CONVERT_LECTURE_PAGES.ADD_TO_LL_DISABLED_IN_PROGRESS_TOOLTIP_TEXT();

  const bulkAddToLessonLibrary = () => {
    checkBulkConvertibleLecturePagesEligibility({
      dispatch,
      aliases: courseAliases,
      courseId: course.id,
      sourceType: BulkAddToCollectionSourceType.COURSE,
      sourceId: course.id,
      onProceed: (convertibleLecturePagesCount) => {
        setBulkConvertibleLessonsCount(convertibleLecturePagesCount);
        setShowBulkAddToLessonModal(true);
      },
    });
  };

  if (canBulkConvertToCollectionLesson === false) {
    return null;
  }

  return (
    <div>
      {isBulkAddToLessonLibraryEnabled && (
        <TopPanelActionButton
          icon='add-to-library'
          tooltipText={bulkAddToCollectionButtonToolTipAndAriaLabelText}
          onClick={bulkAddToLessonLibrary}
          disabled={bulkConvertInProgress}
          dataQa={config.pendo.outline.admin.bulkAddToCollection.bulkAddToCollectionButton}
          ariaLabel={bulkAddToCollectionButtonToolTipAndAriaLabelText}
        />
      )}

      <BulkAddToCollectionModal
        show={showBulkAddToLessonModal}
        onClose={() => setShowBulkAddToLessonModal(false)}
        sourceType={BulkAddToCollectionSourceType.COURSE}
        sourceId={course?.id}
        sourceName={course?.name}
        pageCount={bulkConvertibleLessonsCount}
      />
    </div>
  );
};

export default BulkAddToCollectionButton;
